import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./modules/logged/logged.routes')
            .then(m => m.LOGGED_ROUTES),
    }
];
